export default "__VITE_ASSET__MLRl0TMK__"